<template>
  <div
    class="subtleshadow"
    style="
      flex-grow: 1;
      min-height: 0;
      background: var(--v-cardColor-base);
      display: flex;
      flex-direction: column;
      border-radius: 8px;
    ">
    <div
      style="flex-direction: column; display: flex; height: 55px"
      v-if="!editMode || showChannelActions">
      <ModalHeader
        icon="mdi-play-speed"
        :modalTitle="deluge.items?.[channel_did]?.name"
        :hideCloseBtn="true"
        :modalSubtitle="
          deluge.items[deluge.channels[channel_did]?.live_scene?.did]?.name
            ? deluge.items[deluge.channels[channel_did]?.live_scene?.did]?.name
            : 'No Scene Playing'
        ">
        <template
          v-if="showChannelActions"
          #title>
          <input
            v-if="isEditingName"
            ref="nameInputRef"
            v-model="editingName"
            class="channel-name-input"
            @blur="commitNameChange"
            @keydown.enter="commitNameChange"
            @keydown.escape="cancelNameEdit" />
          <div
            v-else
            class="header-title"
            style="
              font-weight: bold;
              max-width: 310px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 12px;
              cursor: pointer;
            "
            title="Click to rename"
            @click="startNameEdit">
            {{ deluge.items?.[channel_did]?.name }}
          </div>
        </template>
        <template #iconContainer2>
          <div
            @click="state.channelOnAirEditMode = !state.channelOnAirEditMode"
            :class="state.channelOnAirEditMode ? 'ibtn-container-selected' : ''"
            title="Switch to edit mode locally to make changes to the Channel"
            class="ibtn-container mr-2 pa-1 header-icon">
            <v-icon class="header-icon">mdi-pencil</v-icon>
          </div>
          <div
            v-if="showChannelActions"
            @click="showNotesDialog = true"
            title="Channel Notes"
            class="ibtn-container mr-2 pa-1 header-icon">
            <v-icon class="header-icon">mdi-text-box-outline</v-icon>
          </div>
          <div
            v-if="showChannelActions"
            @click="handleExportClick"
            :title="exportArmed ? 'Click again to confirm export' : 'Export Channel'"
            class="ibtn-container mr-2 pa-1 header-icon"
            :class="exportArmed ? 'ibtn-container-selected' : ''">
            <v-icon class="header-icon">{{ exportArmed ? 'mdi-check' : 'mdi-download' }}</v-icon>
          </div>
          <div
            v-if="showChannelActions"
            @click="handleDeleteClick"
            :title="deleteArmed ? 'Click again to confirm delete' : 'Delete Channel'"
            class="ibtn-container mr-2 pa-1 header-icon"
            :style="deleteArmed ? 'background: var(--v-error-base, #f44336); color: white; border-radius: 4px;' : ''">
            <v-icon class="header-icon">{{ deleteArmed ? 'mdi-check' : 'mdi-trash-can' }}</v-icon>
          </div>
        </template>
      </ModalHeader>
    </div>
    <!-- Modals -->
    <v-dialog
      v-model="new_scene_dialog3"
      max-width="1200px"
      max-height="1000px"
      class="template-pop-up">
      <CreateSceneModal
        v-if="new_scene_dialog3"
        :channel_did="channel_did"
        :qid="current_queue"
        :qdid="current_queue_did"
        :go_to_tab="tab"
        :existing_scene="current_scene"
        v-on:advanced="
          new_scene_dialog2 = true;
          new_scene_dialog3 = false;
        "
        v-on:close="
          new_scene_dialog3 = false;
          current_scene = undefined;
        " />
    </v-dialog>
    <v-dialog
      v-model="new_queue_dialog"
      class="template-pop-up template-pop-up-fix"
      max-width="600px">
      <EditQueueModalv2
        :go_to_tab="tab"
        :current_channel="channel_did"
        v-if="new_queue_dialog && current_queue"
        :current_queue="current_queue"
        v-on:close="new_queue_dialog = false" />
    </v-dialog>
    <v-dialog
      v-model="new_queue_simple"
      max-width="600px">
      <NewQueueSimple
        :channel_did="channel_did"
        v-if="new_queue_simple && channel_did"
        v-on:close="new_queue_simple = false" />
    </v-dialog>
    <v-dialog
      v-model="showNotesDialog"
      max-width="500px">
      <v-card v-if="showNotesDialog">
        <ModalHeader
          icon="mdi-text-box-outline"
          modalTitle="Channel Notes"
          @close="closeNotesDialog" />
        <v-card-text class="pt-0">
          <v-textarea
            v-model="notesText"
            filled
            rows="6"
            auto-grow
            placeholder="Add notes or a description for this channel..."
            hide-details />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn
            variant="flat"
            color="primary"
            @click="saveNotes">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div
      :class="editMode ? 'py-3' : ''"
      :style="editMode ? 'height: 100%' : 'height: calc(100% - 59px);'"
      style="
        width: 100%;
        display: flex;
        align-items: stretch;
        justify-content: start;
        overflow: visible;
        padding-left: 8px;
      ">
      <div
        v-if="(channel_did && state.channelOnAirEditMode) || editMode"
        style="
          width: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        ">
        <div
          style="
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            flex: 1;
          "
          @click="new_queue_simple = true"
          class="nicefast mr-3 mb-2 subtleshadow"
          title="Add new Queue">
          <v-icon
            color="white"
            class="d-flex align-center"
            size="large">
            mdi-plus
          </v-icon>
        </div>
      </div>
      <div
        v-if="queues && !loading && channel_did"
        class="queue-container"
        :key="'queue_key' + queue_key">
        <draggable
          :move="queue_move"
          :disabled="
            state.q_is_not_draggable ||
            (!state.channelOnAirEditMode && !editMode)
          "
          @start="start_queue_drag"
          @end="end_queue_drag"
          :animation="150"
          :group="{
            animation: 150,
            group: 'queues',
            put: true,
            pull: true,
            direction: 'horizontal',
          }"
          class="list-group drag-parent-container"
          id="drag-parent-container"
          handle=".handle2"
          @change="moved_in_channel"
          style="
            display: flex;
            flex-wrap: nowrap;
            align-items: start;
            width: 100%;
            padding: 6px;
          "
          :list="queues"
          item-key="did">
          <template #item="{ element, index }">
            <div
              v-if="GetNested(element).did in deluge.items"
              :style="GetNested(element).mini ? '' : 'height: 100%'">
              <div
                v-show="!GetNested(element).mini"
                style="display: flex; height: 100%">
                <div
                  style="
                    display: flex;
                    flex-wrap: nowrap;
                    align-items: start;
                    padding-right: 8px;
                  ">
                  <div
                    class="subtleshadow"
                    style="
                      width: 250px;
                      background: var(--v-cardColor-base);
                      border-radius: 5px;
                      display: flex;
                      height: 100%;
                      flex-direction: column;
                    ">
                    <div
                      class="pa-2 d-flex justify-space-between"
                      style="
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                      ">
                      <div
                        title="Drag to Move Queue"
                        @dragenter="check_if_mini2(false)"
                        class="fast_grey_background"
                        style="
                          border-radius: 4px;
                          display: flex;
                          width: 100%;
                          padding-bottom: 5px;
                        ">
                        <div
                          v-if="IsNested(element)"
                          @click="GoBackQueue(deluge.items[element.did])"
                          class="nicefast top-left-queue-icon mr-1 px-2">
                          <v-icon
                            :color="
                              deluge.items[GetNested(element).did].live
                                ? 'primary'
                                : 'white'
                            "
                            dark>
                            mdi-arrow-left-circle
                          </v-icon>
                        </div>
                        <div
                          v-if="
                            checkOverflow(
                              'queue' + deluge.items[GetNested(element).did].id,
                              element
                            )
                          "
                          class="queue_name px-2 handle2 text-button text-center no_drag queue_name_def">
                          {{ GetNestedName(element) }}
                        </div>
                        <div
                          v-else
                          class="queue_name px-2 handle2 text-button text-center mqtitle">
                          <div class="m2">{{ GetNestedName(element) }}</div>
                        </div>
                      </div>
                    </div>
                    <div
                      style="
                        width: 300px;
                        z-index: 10;
                        height: calc(100% - 100px);
                      "
                      @dragover="check_if_mini2(true)">
                      <div style="width: 250px; display: flex; height: 100%">
                        <div
                          class="scene-container"
                          style="height: 100%">
                          <QueueCardContainer
                            :editMode="editMode"
                            :j="index"
                            :queue="GetNested(element)"
                            :channel_did="channel_did"
                            v-on:openqueue="OpenQueue"
                            v-on:clear_mini="clear_mini()" />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        class="pa-2 pb-1 text-subtitle-2"
                        style="bottom: 0px; width: 100%; height: 42px">
                        <div>
                          <div
                            v-if="!(!state.channelOnAirEditMode && !editMode)"
                            title="Open Queue settings"
                            @click="
                              OpenQueueModal(
                                deluge.items[GetNested(element).did],
                                0
                              )
                            "
                            :style="
                              $vuetify.theme.themes.dark.primary === '#f24c43'
                                ? 'float: left;cursor:pointer;'
                                : 'float: left;cursor:pointer;'
                            "
                            class="nice mr-1 px-2 py-1">
                            <v-icon dark>mdi-cog</v-icon>
                          </div>
                        </div>
                        <div>
                          <div
                            v-if="!state.channelOnAirEditMode && !editMode"
                            title="Switch to this Queue"
                            @click="force_scene(element, channel_did)"
                            :style="
                              $vuetify.theme.themes.dark.primary === '#f24c43'
                                ? 'float: left;cursor:pointer;'
                                : 'float: left;cursor:pointer;'
                            "
                            :class="
                              GetNested(element).live
                                ? 'transbackground_active'
                                : ''
                            "
                            class="nice mr-1 px-2 py-1">
                            <v-icon dark>mdi-chevron-double-right</v-icon>
                          </div>
                        </div>
                        <div
                          @mouseenter="
                            state.sceneConditionSummary =
                              deluge.items[GetNested(element).did]
                          "
                          @mouseleave="state.sceneConditionSummary = false"
                          title="Edit Queue Play Conditions"
                          v-if="
                            deluge.items[GetNested(element).did].valid &&
                            GetNested(element).live &&
                            Object.keys(
                              deluge.items[GetNested(element).did].conditions
                                .play_conditions
                            ).length > 0
                          "
                          @click="
                            OpenQueueModal(
                              deluge.items[GetNested(element).did],
                              1
                            )
                          "
                          :style="
                            $vuetify.theme.themes.dark.primary === '#f24c43'
                              ? 'float: left;cursor:pointer;'
                              : 'float: left;cursor:pointer;'
                          "
                          class="transbackground_active nice mr-1 px-2 py-1">
                          <v-icon dark>mdi-motion-play-outline</v-icon>
                        </div>
                        <div
                          @mouseenter="
                            state.sceneConditionSummary =
                              deluge.items[GetNested(element).did]
                          "
                          @mouseleave="state.sceneConditionSummary = false"
                          v-else-if="
                            Object.keys(
                              deluge.items[GetNested(element).did].conditions
                                .play_conditions
                            ).length > 0
                          "
                          title="Edit Queue Play Conditions"
                          @click="
                            OpenQueueModal(
                              deluge.items[GetNested(element).did],
                              1
                            )
                          "
                          style="cursor: pointer; float: left"
                          class="nice mr-1 px-2 py-1">
                          <v-icon dark>mdi-motion-play-outline</v-icon>
                        </div>

                        <!-- tags -->

                        <div
                          v-if="
                            deluge.items[GetNested(element).did].ingest_tags
                              .length > 0
                          "
                          @click="
                            OpenQueueModal(
                              deluge.items[GetNested(element).did],
                              2
                            )
                          "
                          style="cursor: pointer; float: left"
                          class="nice mr-1 px-2 py-1">
                          <v-icon
                            :color="
                              deluge.items[GetNested(element).did].ingest_tags
                                .length > 0
                                ? 'white'
                                : '#ffffff47'
                            "
                            dark>
                            mdi-filter-plus
                          </v-icon>
                        </div>
                        <div
                          @click="
                            OpenQueueModal(
                              deluge.items[GetNested(element).did],
                              1
                            )
                          "
                          :style="
                            $vuetify.theme.themes.dark.primary === '#f24c43'
                              ? 'cursor:pointer;float: left;'
                              : 'cursor:pointer;float: left;'
                          "
                          class="nice transbackground_active mr-1 px-2 py-1"
                          v-if="
                            deluge.items[GetNested(element).did]
                              .domination_mode > 0 && GetNested(element).live
                          ">
                          <v-icon dark>mdi-star-shooting</v-icon>
                        </div>
                        <div
                          @click="
                            OpenQueueModal(
                              deluge.items[GetNested(element).did],
                              1
                            )
                          "
                          style="cursor: pointer; float: left"
                          class="nice mr-1 px-2 py-1"
                          v-else-if="
                            deluge.items[GetNested(element).did]
                              .domination_mode > 0
                          ">
                          <v-icon
                            :color="
                              deluge.items[GetNested(element).did]
                                .domination_mode > 0
                                ? 'white'
                                : '#ffffff47'
                            "
                            dark>
                            mdi-star-shooting
                          </v-icon>
                        </div>
                        <div
                          @click="
                            OpenQueueModal(
                              deluge.items[GetNested(element).did],
                              2
                            )
                          "
                          :style="
                            $vuetify.theme.themes.dark.primary &&
                            GetNested(element).live === '#f24c43'
                              ? 'cursor:pointer;float: left;'
                              : 'cursor:pointer;float: left;'
                          "
                          v-if="
                            deluge.items[GetNested(element).did].triggers
                              .length > 0
                          "
                          class="nice mr-1 px-2 py-1">
                          <v-icon
                            :color="
                              deluge.items[GetNested(element).did].triggers
                                .length > 0
                                ? 'white'
                                : '#ffffff47'
                            "
                            dark>
                            mdi-share-all
                          </v-icon>
                        </div>
                        <div
                          title="Create new Scene for this Queue"
                          @click="
                            OpenNewAsset(deluge.items[GetNested(element).did])
                          "
                          v-if="!(!state.channelOnAirEditMode && !editMode)"
                          style="cursor: pointer; float: right"
                          class="nice px-2 py-1">
                          <v-icon dark>mdi-plus</v-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <v-lazy
                v-show="GetNested(element).mini"
                min-height="120"
                min-width="230">
                <QueueCard
                  :editMode="editMode"
                  class="mt-1 mb-1"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    height: 120px !important;
                  "
                  v-if="GetNested(element).did in deluge.items"
                  v-show="GetNested(element).mini"
                  :scene="GetNested(element)" />
              </v-lazy>
            </div>
          </template>
        </draggable>
      </div>
    </div>
  </div>
</template>
<script setup>
import draggable from 'vuedraggable';
import EditQueueModalv2 from './EditQueueModalv2.vue';
import NewQueueSimple from './NewQueueSimple.vue';
import QueueCard from './QueueCard.vue';
import NewSceneFromAsset from './NewSceneFromAsset.vue';
import CreateSceneModal from './CreateSceneModal.vue';
import {
  onMounted,
  ref,
  onBeforeUnmount,
  watch,
  defineProps,
  computed,
  nextTick,
} from 'vue';
import { $http } from '../../stores/http.js';
import { state } from '../../stores/deluge.js';
import { deluge } from '@/stores/deluge.js';
import QueueCardContainer from './QueueCardContainer.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';
const ctrl_down = ref(false);
const shift_down = ref(false);

watch(
  () => state.ctrl_down,
  (newVal) => {
    ctrl_down.value = newVal;
  }
);
watch(
  () => state.shift_down,
  (newVal) => {
    shift_down.value = newVal;
  }
);
const props = defineProps(['channel_did', 'editMode', 'showChannelActions']);
const emit = defineEmits(['export-channel', 'delete-channel']);
const isEditingName = ref(false);
const editingName = ref('');
const nameInputRef = ref(null);

// Two-step confirmation for export/delete
const exportArmed = ref(false);
const deleteArmed = ref(false);
let exportTimer = null;
let deleteTimer = null;

function handleExportClick() {
  if (exportArmed.value) {
    exportArmed.value = false;
    clearTimeout(exportTimer);
    emit('export-channel');
  } else {
    exportArmed.value = true;
    deleteArmed.value = false;
    clearTimeout(deleteTimer);
    exportTimer = setTimeout(() => {
      exportArmed.value = false;
    }, 3000);
  }
}

function handleDeleteClick() {
  if (deleteArmed.value) {
    deleteArmed.value = false;
    clearTimeout(deleteTimer);
    emit('delete-channel');
  } else {
    deleteArmed.value = true;
    exportArmed.value = false;
    clearTimeout(exportTimer);
    deleteTimer = setTimeout(() => {
      deleteArmed.value = false;
    }, 3000);
  }
}

function startNameEdit() {
  const item = deluge.items?.[props.channel_did];
  if (!item) return;
  editingName.value = item.name;
  isEditingName.value = true;
  nextTick(() => {
    nameInputRef.value?.focus();
    nameInputRef.value?.select();
  });
}

async function commitNameChange() {
  isEditingName.value = false;
  const item = deluge.items?.[props.channel_did];
  const newName = editingName.value.trim();
  if (!item || !newName || newName === item.name) return;
  try {
    await $http(
      'PUT',
      '/dynamic_engine/update_channel',
      JSON.stringify({ id: item.id, name: newName, description: item.description })
    );
  } catch (error) {
    console.error('Rename failed:', error);
  }
}

function cancelNameEdit() {
  isEditingName.value = false;
}

// Notes dialog
const showNotesDialog = ref(false);
const notesText = ref('');

watch(showNotesDialog, (open) => {
  if (open) {
    const item = deluge.items?.[props.channel_did];
    notesText.value = item?.description || '';
  }
});

async function saveNotes() {
  const item = deluge.items?.[props.channel_did];
  if (!item) return;
  try {
    await $http(
      'PUT',
      '/dynamic_engine/update_channel',
      JSON.stringify({ id: item.id, name: item.name, description: notesText.value })
    );
  } catch (error) {
    console.error('Save notes failed:', error);
  }
  showNotesDialog.value = false;
}

function closeNotesDialog() {
  showNotesDialog.value = false;
}
const current_queue_did = ref(undefined);
const new_scene_dialog3 = ref(false);
const new_scene_dialog2 = ref(false);
const new_queue_dialog = ref(false);
const current_queue = ref(undefined);
const current_scene = ref(null);
const tab = ref(0);
const new_queue_simple = ref(false);
const loading = ref(false);
const queues = ref([]);
const add_queue_shortcut = ref(undefined);
const queue_key = ref(0);
onBeforeUnmount(() => {
  clearTimeout(exportTimer);
  clearTimeout(deleteTimer);
  window.removeEventListener('keydown', add_queue_shortcut.value);
});

onMounted(() => {
  add_queue_shortcut.value = document.addEventListener('keydown', (e) => {
    // Defensive: ensure e.key exists before calling toLowerCase()
    const key = e && e.key ? e.key : undefined;
    if ((e.ctrlKey || e.metaKey) && (key || '').toLowerCase() === 'q') {
      new_queue_simple.value = true;
    }
  });

  handleNestedQueues('onMounted, channel or selectedq changed');
});

const currentChannel = computed(() => {
  return deluge?.channels?.[props.channel_did];
});

watch(currentChannel, () =>
  handleNestedQueues('onMounted, channel or selectedq changed')
);

async function cloneQueue(
  channelDID,
  queueDID,
  indexToCloneInto = undefined,
  queueToCloneInto = undefined
) {
  const queueUid = deluge.items[queueDID].uid;
  const didToCloneInto = queueToCloneInto ? queueToCloneInto : channelDID;

  try {
    const response = await $http(
      'POST',
      '/dynamic_engine/queue_from_queue?queue_uid=' +
        queueUid +
        '&channel_did=' +
        channelDID +
        '&parent_queue_uid=' +
        queueToCloneInto +
        '&index=' +
        indexToCloneInto
    );
  } catch (error) {
    console.log(error);
  }
}

function handleNestedQueues(callingFunc) {
  if (currentChannel.value && !state.selectedq) {
    queues.value = currentChannel.value.queues;

    if (currentChannel.value.queues) {
      const currentChannelsQueues = Object.values(currentChannel.value.queues);

      for (const queue of currentChannelsQueues) {
        if (!(queue.id in state.nested_queues)) {
          state.nested_queues[queue.id] = [];
        }
      }
    }
  }
}

function queue_move(evt) {
  // evt.preventDefault();
  state.qind = evt.draggedContext.futureIndex;
  if (evt.to.classList.contains('queue_group')) {
    if (state.selectedq) {
      state.selectedq['mini'] = true;
    }
  } else {
    if (state.selectedq) {
      state.selectedq['mini'] = false;
    }
  }
  // this.$forceUpdate();
  return true;
}

function start_queue_drag(event) {
  console.log('start_queue_drag');
  if (ctrl_down.value) {
    state.cloneQueue = true;
  }
  state.selecteds = false;
  state.channels_cache = JSON.stringify(deluge.channels);
  const index = event.oldIndex;
  if (!state.selectedq) {
    state.selectedq = queues.value[index];
    //this.$set(state.selectedq, 'mini', true);
  }
  state.q_is_not_draggable = false;
  // const dragParent = document.getElementsByClassName('drag-parent-container');
  // dragParent.classList.add('drag-parent-container-active');

  // event.preventDefault();
  console.log(state.q_is_not_draggable);
}
async function end_queue_drag(ev) {
  if (state.cloneQueue) {
    // Edgecase: if user clones to the right with no queues available to the right, will still clone (moved_in_channel does not fire)

    const queueDid = state.cloneQueueTarget.did;
    const queueIndex = state.cloneQueueTarget.index;
    state.cloneQueueTarget = undefined;

    await cloneQueue(
      props.channel_did,
      state.selectedq.did,
      queueIndex,
      queueDid
    );
  }

  state.cloneQueue = false;

  state.selectedq = undefined;
  state.q_is_not_draggable = false;
  // preventDefault();
  state.cue_drag_active = false;
  const dragParent = document.getElementById('drag-parent-container');
  dragParent.classList.remove('drag-parent-container-active');
  clear_mini();
}

async function moved_in_channel(ev) {
  console.log('move in channel');
  var type = false;
  if (state.cue_drag_active) {
    deluge.channels = state.channels_cache;
    state.cue_drag_active = false;
    return false;
  }
  if (ev.moved) {
    type = 'moved';
  } else if (ev.added) {
    type = 'added';
  }

  if (!type) return;

  if (state.cloneQueue) {
    state.cloneQueue = false;
    await cloneQueue(
      props.channel_did,
      ev[type].element.did,
      ev[type].newIndex
    );
    state.selectedq = undefined;
    clear_mini();
    return;
  }

  var index = state.qind;
  var q_clone = queues.value;
  for (var i = 0; i < queues.value.length; i++) {
    if (q_clone[i].did === ev[type].element.did) {
      q_clone.splice(i, 1);
      break;
    }
  }

  q_clone.splice(index, 0, ev[type].element);
  queues.value = q_clone;
  // this.$forceUpdate();

  if (ev[type].element.newIndex !== ev[type].element.oldIndex) {
    index = ev[type].element.newIndex;
  }

  if (ev[type].element.type !== 'scene') {
    await $http(
      'PUT',
      '/dynamic_engine/dynamic_engine_move_item?drop_to=' +
        props.channel_did +
        '&dropping_item=' +
        ev[type].element.did +
        '&dropping_item_index=' +
        index
    );
  }

  state.selectedq = undefined;
  clear_mini();
}
function clear_mini() {
  for (var i = 0; i < queues.value.length; i++) {
    state.selectedq = undefined;
    if (queues.value[i]) {
      queues.value[i]['mini'] = false;
    }
  }
}
function checkOverflow(el, q) {
  const string = GetNestedName(q);
  if (string.length > 13) {
    return false;
  } else {
    return true;
  }
}
function GetNestedName(q) {
  // Safety check: if the queue item was deleted, return empty string
  if (!deluge.items[q.did]) {
    return '';
  }

  const id = deluge.items[q.did].id;
  var name = deluge.items[q.did].name;
  var qtemp = q;
  if (state.nested_queues[id]) {
    if (state.nested_queues[id].length > 0) {
      for (var i = 0; i < state.nested_queues[id].length; i++) {
        const nextIndex = state.nested_queues[id][i];
        const nextItem = qtemp.items?.[nextIndex];

        // Safety check: if nested item was deleted, stop here
        if (!nextItem || !deluge.items[nextItem.did]) {
          break;
        }

        name = name + ' / ' + deluge.items[nextItem.did].name;
        qtemp = nextItem;
      }
    }
  }
  return name;
}
function GetNested(q) {
  if (deluge.items[q.did]) {
    const id = deluge.items[q.did].id;
    var qtemp = q;
    if (state.nested_queues[id]) {
      if (state.nested_queues[id].length > 0) {
        for (var i = 0; i < state.nested_queues[id].length; i++) {
          const nextIndex = state.nested_queues[id][i];
          const nextItem = qtemp.items?.[nextIndex];

          // Safety check: if the navigation path points to a deleted/missing item,
          // clear the navigation path and return the current position
          if (!nextItem || !deluge.items[nextItem.did]) {
            console.warn(
              '[GetNested] Navigation path points to deleted item, clearing path'
            );
            state.nested_queues[id] = state.nested_queues[id].slice(0, i);
            return qtemp;
          }

          qtemp = nextItem;
        }
      }
    }
    return qtemp;
  } else {
    return q;
  }
}
function IsNested(q) {
  const item = deluge.items[q.did];
  if (item) {
    const id = item.id;

    if (state.nested_queues[id]) {
      if (state.nested_queues[id].length > 0) {
        return true;
      }
    }
  }

  return false;
}
function GoBackQueue(q) {
  // Safety check: if queue doesn't exist or has no navigation state, do nothing
  if (!q || !q.id || !state.nested_queues[q.id]) {
    return;
  }

  q['items_anim'] = true;
  setTimeout(() => {
    if (state.nested_queues[q.id]) {
      state.nested_queues[q.id].pop();
    }
    // this.$forceUpdate();
    q['items_anim'] = false;
  }, 40);
}
function check_if_mini2(toggle) {
  if (toggle) {
    if (state.selectedq) {
      state.selectedq['mini'] = true;
      state.q_is_not_draggable = false;
    } else {
      state.q_is_not_draggable = true;
    }
  } else {
    if (state.selectedq) {
      //this.$set(state.selectedq, 'mini', false);
      state.q_is_not_draggable = false;
    } else {
      state.q_is_not_draggable = true;
    }
  }
}
function OpenNewAsset(uuid) {
  if (uuid) {
    current_queue.value = uuid.id;
    current_queue.value_did = uuid.did;
  }
  current_scene.value = undefined;
  new_scene_dialog3.value = true;
}
function force_scene(queue, channel_ind) {
  queue_key.value += 1;
  $http(
    'GET',
    '/dynamic_engine/go_live?did=' + queue.did + '&channel_did=' + channel_ind
  ).then(() => {});
}
function OpenQueueModal(queue, new_tab) {
  tab.value = new_tab;
  current_queue.value = queue;
  current_queue.value_did = queue.did;
  if (queue && queue.did) {
    new_queue_dialog.value = true;
  }
}
function OpenQueue(data) {
  console.log(data);
  const q = data['q'];
  const nq = data['nq'];
  setTimeout(() => {
    if (q.id) {
      if (!(q.id in state.nested_queues)) {
        state.nested_queues[q.id] = [];
      }
      state.nested_queues[q.id].push(nq);
    }

    console.log(state.nested_queues);
  }, 40);
}
function isAnyPopupOpen() {
  return (
    new_scene_dialog3.value ||
    new_scene_dialog2.value ||
    new_queue_dialog.value ||
    new_queue_simple.value
  );
}
</script>
<style lang="scss" scoped>
.upload-body-dragged {
  color: #fff;
  background-color: #b6d1ec;
}

.button {
  margin-top: 35px;
}

.list-group {
  display: flex;
  flex-wrap: nowrap;
}

.drag-parent-container-active {
  background-color: red;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}

.queue-background {
  overflow-x: auto;
  width: 100%;
  overflow-y: hidden;
}

.queue_name {
  border-radius: 5px;
  color: white;
  width: 100%;
}

.no_drag {
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.scene-container {
  width: 234px;
  background: var(--v-backgroundColor-base);
  border-radius: 5px 5px 0px 0px;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}

.top-left-queue-icon {
  height: 35px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

.queue-container {
  height: 100%;
  width: 100%;
  user-select: none;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 6px;
  position: relative;
  margin-right: 8px;
}

.drag-parent-container {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  width: max-content; /* Ensure it adapts to its content */
  overflow-x: auto; /* Enable horizontal scrolling if needed */
}

.mqtitle {
  height: 30px;
  font-size: 13px;
  cursor: grab;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top-right-queue-icon {
  height: 35px;
  display: flex;
  align-items: center;
}

.queue_name_def {
  height: 30px;
  font-size: 13px;
  cursor: grab;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.m2 {
  animation: marquee 8s linear infinite;
  display: inline-block;
  padding-left: 100%;
}

@keyframes marquee {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
  }
}

@media only screen and (max-width: 600px) {
  .player_manager {
    height: 180px;
  }
}
.channel-name-input {
  font-weight: bold;
  font-size: 12px;
  max-width: 310px;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--primary-color);
  outline: none;
  color: var(--text);
  padding: 0;
  line-height: 1.4;
}
</style>
